export default function trackEvent(...args) {
  if (window.ga && typeof window.ga === 'function' && window.ga.getAll().length > 0) {
    window.ga(`${window.ga.getAll()[0].get('name')}.send`, 'event', ...args);
  } else {
    console.log('[TrackEvent] GA is not loaded, but here\'s the event data:', ...args);
  }
}
